export function WarningIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 16 16"
      fill="none"
      color="currentColor"
    >
      <g clipPath="url(#clip0_7327_40250)">
        <path
          d="M8.89971 2.51375L14.366 12.0056C14.7491 12.6744 14.2541 13.5 13.4653 13.5H2.53284C1.74409 13.5 1.24909 12.6744 1.63221 12.0056L7.09846 2.51375C7.49221 1.82875 8.50596 1.82875 8.89971 2.51375Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8 9V6.5"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8 11.875C8.34518 11.875 8.625 11.5952 8.625 11.25C8.625 10.9048 8.34518 10.625 8 10.625C7.65482 10.625 7.375 10.9048 7.375 11.25C7.375 11.5952 7.65482 11.875 8 11.875Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_7327_40250">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
